export default {"src":"/_next/static/media/linked-in.b3b1cfde.svg","height":24,"width":24};